
/**
 *  * First we will load all of this project's JavaScript dependencies which
 *   * includes Vue and other libraries. It is a great starting point when
 *    * building robust, powerful web applications using Vue and Laravel.
 *     */

import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
import store from './store';
import {isEqual, isBefore, isAfter } from 'date-fns'

require('./bootstrap');
window.axios = require('axios');
window.Vue = require('vue');


// Quill editor
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'



// Initialize Vuetiify
const vuetifyOptions = { }
Vue.use(Vuetify);
Vue.use(VueQuillEditor);
Vue.config.productionTip = false;

window.Event = new Vue();


/**
 *  * Next, we will create a fresh Vue application instance and attach it to
 *   * the page. Then, you may begin adding components to this application
 *    * or customize the JavaScript scaffolding to fit your unique needs.
 *     
 * */
Vue.component('advise-component', require('./components/Advise.vue').default);
Vue.component('advise-dashboard-component', require('./components/AdviseDashboard.vue').default);
Vue.component('advise-removed-component', require('./components/AdviseRemoved.vue').default);
Vue.component('banner-approval-audit', require('./components/BannerApprovalAudit.vue').default);
Vue.component('banner-hold-audit', require('./components/BannerHoldAudit.vue').default);

Vue.component('advisepdf-component', require('./components/AdvisePdf.vue').default);

Vue.component('scheduler-component', require('./components/Scheduler.vue').default);
Vue.component('advisor-preference', require('./components/AdvisorPreference.vue').default);
Vue.component('appointment-index-component', require('./components/AppointmentIndexComponent.vue').default);
Vue.component('placement-index-component', require('./components/PlacementIndexComponent.vue').default);
Vue.component('housing-index-component', require('./components/DoorLockUserIndexComponent.vue').default);
Vue.component('deferredstars-index-component', require('./components/DeferredStarsIndexComponent.vue').default);
Vue.component('deferredstars-index-stars-component', require('./components/DeferredStarsIndexStarsComponent.vue').default);
Vue.component('notes-indexbyuin-component', require('./components/NotesByUINComponent.vue').default);
Vue.component('appointments-indexbyuin-component', require('./components/AppointmentsByUINComponent.vue').default);
Vue.component('external-scheduler-component', require('./components/ExternalAdviseeScheduler.vue').default);
Vue.component('advisors-list-component', require('./components/AdvisorsList.vue').default);

Vue.component('logout-timer-component', require('./components/LogoutTimerComponent.vue').default);
Vue.component('appsessions-index-component', require('./components/AppSessionsIndexComponent.vue').default);
Vue.component('user-impersonate', require('./components/user/Index.vue').default);

Vue.mixin({
    data() {
        return {
            alert: false,
            status: { message: '', type: '' },
        };
    },
    methods: {
        displayStatusMessage(msg, type) {
            this.status.message = msg;
            this.status.type = type;
            this.alert = true;
          },
          resetAlert() {
            this.status.message = '';
            this.status.type = '';
            this.alert = false;
          },
          isDateSameOrBefore(date, dateToCompare) {
            return isEqual(new Date(date), new Date(dateToCompare)) || isBefore(new Date(date), new Date(dateToCompare)) 
          },
          isDateSameOrAfter(date, dateToCompare) {
            return isEqual(new Date(date), new Date(dateToCompare)) || isAfter(new Date(date), new Date(dateToCompare)) 
          },
          isDateInBetween(date, startDateToCompare,  endDateToCompare) {
            return isAfter(new Date(date), new Date(startDateToCompare)) && isBefore(new Date(date), new Date(endDateToCompare)) 
          },
    }
});

import XLSX from 'xlsx';
Vue.use(XLSX);
require('xlsx');

import VueFlashMessage from 'vue-flash-message';
Vue.use(VueFlashMessage);
require('vue-flash-message/dist/vue-flash-message.min.css');

const app = new Vue({
    el: '#app',
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    store,
    vuetify: new Vuetify(vuetifyOptions),
}).$mount('#app');

